import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  DevNote,
  FormFieldSet,
  PageHeader,
  PageTitle,
  showToast,
  SmartTooltip,
  ToolTip,
  useFormHandler,
} from "../../../../components";

import { RecordStatus } from "../../../../assets/data/enumData";
import { fetchLatestUiid } from "../../../../redux/slices/employee/employeeApi";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import {
  addNewClientStart,
  addToDraft,
  clearClientProfile,
  getClientOneStart,
  setClientProfile,
  updateClientStart,
} from "../../../../redux/slices/client/clientSlice";
import { useDispatch, useSelector } from "react-redux";
import { filterEmptyValues } from "../../../../utils/filterEmptyValues";
import { useNavigate, useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { validate as uuidValidate, version as uuidVersion } from "uuid";
import { debounce } from "../../../../utils";

const BusinessInformation = ({
  setActiveTab,
  isEditable,
  editClient = "",
  clientId,
}) => {
  const clientDetails = useSelector(
    (state) => state.client.currentClient.clientDetails,
  );
  const clientProfileUiid = useSelector(
    (state) => state.client.clientProfileUiid,
  );
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const [latestUiid, setLatestUiid] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [IdsToPull, setIdsToPull] = useState({
    client: [],
  });
  const navigate = useNavigate();
  const location = useLocation();

  // const initialState = {
  //   businessName: clientDetails?.businessName || "",
  //   clientId: latestUiid || "",
  //   email: clientDetails.email || "",
  //   federalId: clientDetails.federalId || "",
  //   contactNumber: clientDetails?.contact?.number || "",
  //   countryCode: clientDetails?.contact?.code || "",
  //   website: clientDetails?.website || "",
  //   recordStatus:
  //     clientDetails?.recordStatus === 1
  //       ? 1
  //       : clientDetails?.recordStatus === 2
  //       ? 2
  //       : 0,
  //   ownership: clientDetails?.ownership === 1 ? 1 : 2 || 1,
  // };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      // {
      //   businessName: clientDetails?.businessName || "",
      //   clientId: latestUiid || "",
      //   email: clientDetails.email || "",
      //   federalId: clientDetails.federalId || "",
      //   countryCode: clientDetails?.contact?.code || "",
      //   contactNumber: clientDetails?.contact?.number || "",
      //   website: clientDetails?.website || "",
      //   recordStatus:
      //     clientDetails?.recordStatus === 1
      //       ? 1
      //       : clientDetails?.recordStatus === 2
      //       ? 2
      //       : 0,
      //   ownership: clientDetails?.ownership === 1 ? 1 : 2 || 1,
      // },
      {
        businessName: "",
        clientId: latestUiid || "",
        email: "",
        federalId: "",
        // countryCode: "",
        contactNumber: [],
        website: "",
        recordStatus: "",
        shortCode: "",
        ownership: 1,
        name: [
          {
            id: uuidv4(),
            name: "",
            type: "",
            email: [],
            mobileNumber: "",
          },
        ],
      },
      // initialState,
      {
        businessName: { type: "text", required: true },
        recordStatus: { type: "select", required: true },
        shortCode: { type: "text", required: true, casing: "upper" },
        // federalId: { type: "alphanumeric", required: true },
        email: { type: "email", required: true, multiple: true },
        // contactNumber: { type: "phone", required: true },
      },
    );
  //prefill
  useEffect(() => {
    if (location.state?.incomingData) {
      const incoming = location.state.incomingData;
      handleChange("businessName", incoming.businessName || "");
      handleChange("email", incoming.email || []);
      handleChange("federalId", incoming.federalId || "");
      handleChange("contactNumber", incoming.contactNumber || []);
      handleChange("website", incoming.website || "");
      if (incoming.name && incoming.name.length > 0) {
        handleChange("name", incoming.name);
      }
    } else if (clientProfileUiid || Object.keys(clientDetails).length) {
      handleChange(
        "businessName",
        clientDetails?.businessName ? clientDetails?.businessName : "" || "",
      );
      handleChange("clientId", latestUiid || "");
      handleChange("email", clientDetails?.email || []);
      handleChange("federalId", clientDetails?.federalId || "");
      const phoneData = clientDetails?.phone ?? [];
      const lastCode =
        phoneData.length > 0 ? phoneData[phoneData.length - 1].code : "+91";

      const updateData = [...phoneData, { code: lastCode, number: "" }];

      handleChange("contactNumber", updateData);
      // handleChange("contactNumber", phoneData);
      handleChange("website", clientDetails?.website || "");
      handleChange(
        "recordStatus",
        clientDetails?.recordStatus === 1
          ? 1
          : clientDetails?.recordStatus === 2
            ? 2
            : undefined,
      );
      handleChange("shortCode", clientDetails?.shortCode || "");
      handleChange("ownership", clientDetails?.ownership === 1 ? 1 : 2 || 1);
      handleChange(
        "name",
        clientDetails?.roleContacts?.length > 0
          ? clientDetails.roleContacts.map((a) => {
              const phoneData = a?.phone ?? [];
              const lastCode =
                phoneData.length > 0
                  ? phoneData[phoneData.length - 1].code
                  : "+91";

              return {
                id: a._id,
                type: a.role,
                email: a.email,
                name: a.name,
                mobileNumber: [...phoneData, { code: lastCode, number: "" }],
              };
            })
          : [
              {
                id: uuidv4(),
                type: "",
                email: [],
                name: "",
                mobileNumber: [{ code: "+91", number: "" }],
              },
            ],
      );
    }
    // }, [clientDetails, clientProfileUiid]);
    // }, [clientProfileUiid, Object.keys(clientDetails).length]);
  }, [clientProfileUiid, location.state]);
  useEffect(() => {
    dispatch(
      getClientOneStart({
        clientUiid: clientProfileUiid,
        retrieve: `businessName roleContacts phone generalInfo.invoiceLocation uiid email federalId contact website recordStatus shortCode ownership`,
        //
        ref: "PlacementWithEmp",
        incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.jobCode",
      }),
    );
    const fetchLatestUiidData = async () => {
      try {
        const response = await fetchLatestUiid("clients");
        const count = response?.data?.data?.count;
        if (typeof count === "number") {
          setLatestUiid(count + 1);
          handleChange("clientId", count + 1);
        } else {
          setLatestUiid(1);
          handleChange("clientId", 1);
        }
      } catch (error) {
        console.error("Error fetching latest UIID:", error);
        showToast("Error fetching latest UIID", "error", 5000);
      }
    };
    if (!clientId) {
      if (clientProfileUiid) {
        setLatestUiid(clientProfileUiid);
      } else {
        fetchLatestUiidData();
      }
    }
    if (clientId) {
      setLatestUiid(clientId);
    }
  }, [clientId, clientProfileUiid]);

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      setIsLoading(true);
      try {
        //         roleContacts: {
        //   type: [{
        //     _id: { type: Schema.Types.ObjectId, default: () => new Types.ObjectId() },
        //     role: String,
        //     email: [EmailField],
        //     phone: [PhoneFormatSchema]
        //   }]
        // },
        // let prepareSubmissionData = {
        let prepareSubmissionData = {
          _skipFlatten: ["email", "phone", "roleContacts"],
          addedBy: loginUserUiid,
          incomingPlacementId: location?.state?.incomingData?.incomingPlacementId,
          businessName: formData.businessName,
          email: formData.email,
          phone: Array.isArray(formData.contactNumber)
            ? formData.contactNumber.filter(
                // (data) => data?.code && data?.number?.trim()
                (data) => data?.code && data?.number,
              ).map(data => ({ ...data, number: Number(String(data.number).replace(/\D/g, '')) }))
            : [],
          federalId: formData.federalId,
          website: formData.website,
          recordStatus: formData.recordStatus,
          shortCode: formData.shortCode,
          ownership: formData.ownership,
          roleContacts: formData.name
            .filter((role) => {
              if (!clientProfileUiid) return true;
              return !uuidValidate(role.id) || uuidVersion(role.id) !== 4;
            })
            .map((role) => ({
              role: role.type,
              email: role.email,
              name: role.name,
              phone: Array.isArray(role.mobileNumber)
                ? role.mobileNumber.filter(
                    // (data) => data?.code && data?.number?.trim()
                    (data) => data?.code && data?.number,
                  ).map(data => ({ ...data, number: Number(String(data.number).replace(/\D/g, '')) }))
                : [],
            })),
          onSuccess: (data) => {
            setActiveTab((prev) => prev + 1);
          },
        };
        let newContacts = formData.name.filter(
          // (role) => uuidValidate(role.id) && uuidVersion(role.id) === 4
          (role) => uuidValidate(role.id),
        );

        // let submissionData = filterEmptyValues(prepareSubmissionData);
        // return;
        //api work
        if (clientProfileUiid) {
          dispatch(
            updateClientStart({
              uiid: clientProfileUiid,
              coll: "Client",
              payload: [{ type: "SET", value: prepareSubmissionData }],
              onSuccess: async () => {
                const updatePromises = [];

                if (IdsToPull.client.length > 0) {
                  IdsToPull.client.forEach((ids) => {
                    updatePromises.push(
                      dispatch(
                        updateClientStart({
                          suppressToast: true,
                          uiid: clientProfileUiid,
                          coll: "Client",
                          payload: [
                            {
                              type: "PULL",
                              value: {
                                roleContacts: { _id: ids },
                              },
                            },
                          ],
                        }),
                      ),
                    );
                  });
                }

                if (newContacts.length > 0) {
                  updatePromises.push(
                    dispatch(
                      updateClientStart({
                        suppressToast: true,
                        uiid: clientProfileUiid,
                        coll: "Client",
                        payload: [
                          {
                            type: "PUSH",
                            value: {
                              roleContacts: newContacts.map((role) => ({
                                role: role.type,
                                email: role.email,
                                name: role.name,
                                phone: Array.isArray(role.mobileNumber)
                                  ? role.mobileNumber.filter(
                                      (data) =>
                                        // data?.code && data?.number?.trim()
                                        data?.code && data?.number,
                                    ).map(data => ({ ...data, number: Number(String(data.number).replace(/\D/g, '')) }))
                                  : [],
                              })),
                            },
                          },
                        ],
                      }),
                    ),
                  );
                }

                await Promise.all(updatePromises);

                dispatch(
                  getClientOneStart({
                    clientUiid: clientProfileUiid,
                    retrieve: `businessName roleContacts generalInfo.invoiceLocation uiid email federalId contact website recordStatus shortCode ownership`,
                    ref: "PlacementWithEmp",
                    incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.jobCode",
                  }),
                );
                setActiveTab((prev) => prev + 1);
              },
            }),
          );
          //can remove
          // dispatch(setClientProfile(submissionData));
        } else {
          dispatch(addNewClientStart(prepareSubmissionData));
          dispatch(setClientProfile(prepareSubmissionData));
          // setActiveTab((prev) => prev + 1);
        }
      } catch (error) {
        showToast(
          error.message || "Error submitting client data",
          "error",
          5000,
        );
        console.error("Error submitting client data:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      showToast("Please fix the errors before submitting.", "error", 5000);
    }
  };

  const handleBack = () => {
    setTimeout(() => {
      // Move to back tab
      setActiveTab((prev) => prev - 1);
    }, 500);
  };
  // const debounce = (fn, delay) => {
  //   let timer;
  //   return (...args) => {
  //     clearTimeout(timer);
  //     timer = setTimeout(() => {
  //       timer = null;
  //       fn(...args);
  //     }, delay);
  //   };
  // };
  // testing
  // const handleDraft = debounce((field, value) => {
  //   dispatch(
  //     addToDraft({
  //       [field]: value ? value : "",
  //     })
  //   );
  // },1000);
  //working
  const handleDraft = useMemo(
    () =>
      debounce((value) => {
        dispatch(
          // addToDraft({
          //   [field]: value ? value : "",
          // })
          addToDraft({ ...value }),
        );
      }, 1000),
    [dispatch],
  );
  useEffect(() => {
    let clientData = {
      businessName: formData.businessName,
      email: formData.email,
      federalId: formData.federalId,
      phone: formData.contactNumber,
      website: formData.website,
      recordStatus: formData?.recordStatus,
      shortCode: formData.shortCode,
      ownership: formData.ownership,
      roleContacts: formData.name.map((role) => ({
        role: role.type,
        email: role.email,
        name: role.name,
        phone: Array.isArray(role.mobileNumber)
          ? role.mobileNumber.filter((data) => data?.code && data?.number)
          : [],
      })),
    };
    // if (clientProfileUiid || Object.keys(clientDetails).length > 0) {
    handleDraft(clientData);
    // }
  }, [formData]);

  //testing
  // const timerRef = useRef(null)

  // const handleDraft = (field, value) => {
  //   clearTimeout(timerRef.current)
  //   timerRef.current = setTimeout(() => {
  //     dispatch(
  //       addToDraft({
  //         [field]: value || "",
  //       })
  //     )
  //   }, 2000)
  // }

  // may work
  //   const handleDraft = useMemo(() =>
  //   debounce((field, value) => {
  //     dispatch(
  //       addToDraft({
  //         [field]: value || "",
  //       })
  //     );
  //   }, 2000),
  // [dispatch]
  // );

  return (
    <div className="flex flex-col w-full h-full px-8 py-3 overflow-auto rounded">
      <DevNote>
        Client ID{clientId}clientProfileUiid:{clientProfileUiid}
        <Button
          onClick={() => dispatch(clearClientProfile())}
          variant="outlined"
          icon={"clear"}
          title={"Clear Draft"}
        />
      </DevNote>
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle
                title={"Business Information"}
                icon={"badge"}
                tag="h5"
              />
            </div>
          }
          RightSection={
            <>
              {/* {!isEditable ? (
                <>
                  <Button title="Save" size="sm" onClick={handleSave} />
                </>
              ) : null} */}
              {isEditable && editClient && (
                <>
                  {editClient !== "/client/client-details" && (
                    <Button
                      title="Back"
                      size="sm"
                      icon={"arrow_left_alt"}
                      onClick={() => navigate("/client")}
                    />
                  )}

                  <Button title="Save" size="sm" onClick={handleSave} />
                </>
              )}
            </>
          }
        />
      </div>
      <div className="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-7xl">
        <div>
          <FormFieldSet
            type="text"
            title={"Busines Name"}
            placeholder="Enter Business Name"
            value={formData.businessName}
            onChange={(value) => {
              handleChange("businessName", value);
            }}
            error={errors.businessName}
            required
            disabled={!isEditable}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Client ID"}
            placeholder="Enter Client ID"
            // value={formData.employeeId}
            value={latestUiid}
            //onChange={(value) => handleChange("clientId", value)}
            error={errors.clientId}
            //required
            disabled
          />
        </div>
        <div>
          <FormFieldSet
            type={"email"}
            title={
              <ToolTip
                size="sm"
                description={"Please type and enter"}
                color="primary"
              >
                <span className="mr-1">Email</span>
              </ToolTip>
            }
            placeholder="Enter Email"
            value={formData.email}
            onChange={(value) => {
              handleChange("email", value);
            }}
            error={errors.email}
            disabled={!isEditable}
            multiple
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Federal ID"}
            placeholder="Enter Federal ID"
            value={formData.federalId}
            onChange={(value) => {
              handleChange("federalId", value);
            }}
            error={errors.federalId}
            disabled={!isEditable}
            alphanumeric
          />
        </div>
        <div>
          <FormFieldSet
            type={"phoneNew"}
            // title={"Contact Numbers"}
            title={
              <ToolTip
                size="sm"
                description={"Please type and enter"}
                color="primary"
              >
                <span className="mr-1">Contact Numbers</span>
              </ToolTip>
            }
            placeholder="Enter Contact Numbers"
            values={formData.contactNumber || []}
            multiple
            onChange={(e) => {
              handleChange("contactNumber", e);
            }}
            error={errors.contactNumber}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Website"}
            // placeholder="Enter Website"

            placeholder="https://www.domain.com/"
            value={formData.website}
            onChange={(value) => {
              handleChange("website", value);
            }}
            error={errors.website}
            disabled={!isEditable}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Record Status"}
            placeholder="Select Record Status"
            options={RecordStatus}
            value={formData.recordStatus}
            onChange={(value) => handleChange("recordStatus", value)}
            error={errors.recordStatus}
            disabled={!isEditable}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            placeholder="Enter Client Short Code"
            title={
              <div>
                Client Short Code
                <span className="ml-1 text-xs text-primary">Not editable!</span>
              </div>
            }
            value={formData.shortCode}
            onChange={(value) => handleChange("shortCode", value)}
            error={errors.shortCode}
            disabled={editClient === "/client/client-details"}
          />
        </div>
      </div>
      <div className="mt-6">
        <div className="mb-3">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"Client Ownership"} tag="h6" />
              </div>
            }
          />
        </div>

        <FormFieldSet
          type="radio"
          title={""}
          placeholder="Enter Zip Code"
          options={[
            {
              label: "Visible to All",
              value: 1,
            },
            {
              label: "Visible to selected Owners",
              value: 2,
            },
          ]}
          value={formData.ownership}
          onChange={(event) => handleChange("ownership", event.target.value)}
          error={errors.ownership}
          disabled={!isEditable}
        />
      </div>
      <div className="grid grid-cols-1 gap-y-4 max-w-7xl mt-6">
        {formData.name.map((hr, index) => (
          <div
            key={hr.id}
            className="grid grid-cols-3 xl:grid-cols-[repeat(4,1fr)_30px] gap-x-4"
          >
            <div>
              <FormFieldSet
                type="roleType"
                title={"Type"}
                placeholder="Type"
                value={hr.type}
                onChange={(value) =>
                  handleChange(`name[${index}].type`, value.value)
                }
                error={errors?.name?.[index]?.type}
                disabled={!isEditable}
                // disabled={true}
                showButton
                showSearch
              />
            </div>
            <div>
              <FormFieldSet
                type="text"
                title={"Name"}
                placeholder="Enter name"
                value={hr.name}
                onChange={(value) => handleChange(`name[${index}].name`, value)}
                error={errors?.name?.[index]?.name}
                disabled={!isEditable}
              />
            </div>
            <div>
              <FormFieldSet
                // type="text"
                type="email"
                title={"Email"}
                placeholder="Enter Email"
                value={hr.email}
                onChange={(value) =>
                  handleChange(`name[${index}].email`, value)
                }
                disabled={!isEditable}
                multiple
              // disabled={true}
              />
            </div>
            <div>
              <FormFieldSet
                type={"phoneNew"}
                title={"Phone Numbers"}
                placeholder="Enter Contact Numbers"
                values={hr.mobileNumber || []}
                multiple
                onChange={(e) => {
                  handleChange(`name[${index}].mobileNumber`, e);
                }}
                error={errors?.name?.[index]?.mobileNumber}
                disabled={!isEditable}
              />
            </div>

            <div className="flex items-center">
              <div className="flex gap-2 mt-3 lg:mt-8 items-center">
                <Button
                  type="icon"
                  icon="add"
                  size="xs"
                  color="black"
                  onClick={() => {
                    if (formData.name.length > 4) return;
                    const newHR = {
                      id: uuidv4(),
                      name: "",
                      type: "",
                      email: "",
                      mobileNumber: "",
                    };
                    handleChange("name", [...formData.name, newHR]);
                  }}
                />
                <Button
                  type="icon"
                  icon="remove"
                  size="xs"
                  color="danger"
                  disabled={formData.name.length === 1}
                  onClick={() => {
                    const isUiid = uuidValidate(formData.name[index].id);
                    if (!isUiid) {
                      setIdsToPull((prev) => ({
                        client: [...prev.client, formData.name[index].id],
                      }));
                    }
                    const updatedHRDetails = formData.name.filter(
                      (_, i) => i !== index,
                    );
                    handleChange("name", updatedHRDetails);
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessInformation;
